import React from 'react';
import { Lightbulb, Check, X, ArrowRight } from 'lucide-react';
import { PaymentIcons } from './PaymentIcons';
export function ReframeSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-286">
      <div className="max-w-5xl mx-auto" data-id="element-287">
        <div className="flex items-center justify-center mb-10" data-id="element-288">
          <Lightbulb size={32} className="text-orange-500 mr-3" data-id="element-289" />
          <h2 className="text-3xl font-bold text-gray-800" data-id="element-290">
            A New Perspective
          </h2>
        </div>
        <div className="bg-teal-50 rounded-lg p-8 mb-12" data-id="element-291">
          <h3 className="text-2xl font-semibold text-gray-800 mb-6 text-center" data-id="element-292">
            But listen to this...
          </h3>
          <p className="text-xl text-gray-800 mb-6" data-id="element-293">
            You're not sick because you lack medication. You're inflamed from
            years of misinformation disguised as advice.
          </p>
          <p className="text-xl font-bold text-teal-700 mb-8 text-center" data-id="element-294">
            And that... can be changed.
          </p>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-295">
            <div data-id="element-296">
              <h4 className="text-xl font-semibold text-orange-600 mb-4" data-id="element-297">
                What you DON'T need:
              </h4>
              <ul className="space-y-3" data-id="element-298">
                <li className="flex items-start" data-id="element-299">
                  <X size={22} className="text-orange-500 mr-2 mt-1 flex-shrink-0" data-id="element-300" />
                  <p className="text-lg text-gray-700" data-id="element-301">
                    To be a professional chef
                  </p>
                </li>
                <li className="flex items-start" data-id="element-302">
                  <X size={22} className="text-orange-500 mr-2 mt-1 flex-shrink-0" data-id="element-303" />
                  <p className="text-lg text-gray-700" data-id="element-304">
                    A restrictive military diet
                  </p>
                </li>
                <li className="flex items-start" data-id="element-305">
                  <X size={22} className="text-orange-500 mr-2 mt-1 flex-shrink-0" data-id="element-306" />
                  <p className="text-lg text-gray-700" data-id="element-307">
                    To spend hundreds of dollars on miracle products
                  </p>
                </li>
              </ul>
            </div>
            <div data-id="element-308">
              <h4 className="text-xl font-semibold text-teal-700 mb-4" data-id="element-309">
                What you DO need:
              </h4>
              <ul className="space-y-3" data-id="element-310">
                <li className="flex items-start" data-id="element-311">
                  <Check size={22} className="text-teal-700 mr-2 mt-1 flex-shrink-0" data-id="element-312" />
                  <p className="text-lg text-gray-700" data-id="element-313">
                    A real and practical guide
                  </p>
                </li>
                <li className="flex items-start" data-id="element-314">
                  <Check size={22} className="text-teal-700 mr-2 mt-1 flex-shrink-0" data-id="element-315" />
                  <p className="text-lg text-gray-700" data-id="element-316">
                    Simple and effective recipes
                  </p>
                </li>
                <li className="flex items-start" data-id="element-317">
                  <Check size={22} className="text-teal-700 mr-2 mt-1 flex-shrink-0" data-id="element-318" />
                  <p className="text-lg text-gray-700" data-id="element-319">
                    The internal decision to trust your body again
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-10 text-center" data-id="element-320">
            <p className="text-lg text-gray-700 mb-4" data-id="element-321">
              Ready to transform your health with the power of food?
            </p>
            <a href="https://ebooksociety.co/cart/51407721562393:1?checkout" className="bg-orange-600 hover:bg-orange-700 text-white font-bold py-3 px-8 rounded-lg inline-flex items-center transition shadow-md" data-id="element-322">
              Get Your Recipe eBook Today
              <ArrowRight size={18} className="ml-2" data-id="element-323" />
            </a>
            <div className="max-w-md mx-auto" data-id="element-324">
              <PaymentIcons data-id="element-325" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}